// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SubNavigation_wrapper__3ATQF","navItem":"SubNavigation_navItem__GYGqD"};